import * as React from 'react';
import {
  Datagrid,
  DateField,

  List,
  SimpleShowLayout,
  TextField,
  TextInput,
  NumberField,

  ReferenceField,
  ReferenceInput,
  required,
  AutocompleteInput,
} from "react-admin";
import EditView from "../../components/EditView";
import CreateView from "../../components/CreateView";
import ShowView from "../../components/ShowView";


import { IdateInput } from '../../data/IdateTimeInput';

export const TransactionList = (props) => (

  <List {...props} sort={{ field: 'date', order: 'DESC' }} >
    <Datagrid rowClick="edit">
      <TextField source="title" />
      <TextField source="description" />
      <NumberField source="amount" />
      <NumberField source="invoiceId" />
      <NumberField source="count" />
      <ReferenceField link={null} source="createdBy" reference="adminUsers" >
        <TextField source="name" />
      </ReferenceField>
      <DateField locales={"fa-IR"} source="date" />
      <DateField locales={"fa-IR"} source="createdAt" />
    </Datagrid>
  </List>
);

export const TransactionEdit = (props) => (
  <EditView {...props} perPage={10}>
    <TextInput source="title" validate={required()} />
    <TextInput source="description" validate={required()} />
    <TextInput source="invoiceId" validate={required()} />
    <TextInput source="amount" validate={required()} />
    <TextInput source="count" validate={required()} />
    <ReferenceField source="customerId" reference="customer" >
      <TextField source="name" />
    </ReferenceField>
    <IdateInput source='date' validate={required()}  />

  </EditView>
);

export const TransactionShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="title" />
      <TextField source="description" />
      <TextField source="invoiceId" />
      <TextField source="amount" />
      <TextField source="count" />
      <ReferenceField link={null} source="createdBy" reference="adminUsers" >
        <TextField source="name" />
      </ReferenceField>
      <ReferenceField link={null} source="customerId" reference="customer" >
        <TextField source="name" />
      </ReferenceField>
      <DateField locales={"fa-IR"} source="date" />
      <DateField locales={"fa-IR"} source="createdAt" />
    </SimpleShowLayout>
  </ShowView>
);

export const TransactionCreate = (props) => (
  <CreateView {...props}>
    <TextInput source="title" validate={required()} />
    <TextInput source="description" />
    <TextInput source="invoiceId" validate={required()} />
    <TextInput source="amount" validate={required()} />
    <TextInput source="count" validate={required()} />
    <ReferenceInput link={null} source="customerId" reference="customer" >
      <AutocompleteInput source="name" />
    </ReferenceInput>
    <IdateInput variant="outlined" source='date' validate={required()}  />
  </CreateView>
);
